import React, { Fragment, useState } from 'react'

import styles from './Zapier.module.css'

import Link from 'Design/components/Link'
import Label from 'Design/components/Label'
import FormControl from 'Design/components/FormControl'
import CopyInput from 'Src/b/components/CopyInput'

import { useResetAPIKeyMutation } from './zapier.service'
import UnInstallZapier from './UnInstallZapier'

const ManageZapier = (props) => {
  const { settings } = props

  const [apiKey, setApiKey] = useState(settings.api_key)
  const [resetAPIKey, resetAPIKeyResult] = useResetAPIKeyMutation()

  const handleRegenerateKey = async () => {
    const { data } = await resetAPIKey()
    setApiKey(data.api_key)
  }

  const showCopyIcon = resetAPIKeyResult.isSuccess || false

  return (
    <Fragment>
      <FormControl>
        <Label className={styles.RegenerateButtonContainer}>
          Your API Key{' '}
          {!showCopyIcon && (
            <Link className={styles.RegenerateButton} onClick={handleRegenerateKey}>
              (Regenerate key)
            </Link>
          )}
        </Label>
        <CopyInput value={apiKey} canCopy={showCopyIcon} />
      </FormControl>
      {showCopyIcon && <p>Note: Please save this token safely, It will not be shown next time.</p>}
      <UnInstallZapier disabled={resetAPIKeyResult.isLoading} />
    </Fragment>
  )
}

export default ManageZapier
